import actionCreatorFactory from 'typescript-fsa';

import { FormName } from '@topconagriculture/feed-types';

import reduxConfig from '../../config';
import {
  AddIngredientRequestPayload,
  AddInventoryStockPayload,
  DailyUsage,
  EditIngredientPayload,
  EditIngredientSettingsPayload,
  EditTolerancePayload,
  Ingredient,
  IngredientStock,
} from './ingredients.types';

const actionCreator = actionCreatorFactory(reduxConfig.appName + '/ingredient');

export const getIngredientsListRequest = actionCreator.async<any, any>('[GET_INGREDIENTS]');
export const getIngredientRequest = actionCreator.async<any, any>('[GET_INGREDIENT]');
export const getAllIngredientsRequest = actionCreator.async<any, any>('[GET_ALL_INGREDIENTS]');
export const addIngredientRequest = actionCreator.async<AddIngredientRequestPayload, any>('[ADD_INGREDIENT]');
export const editIngredientRequest = actionCreator.async<EditIngredientPayload, any>('[UPDATE_INGREDIENT]');
export const renameIngredient = actionCreator.async<FormName, any>('[RENAME_PREMIX]');
export const deleteIngredientRequest = actionCreator.async<FormName, any>('[DELETE_INGREDIENT]');
export const getIngredientsBatch = actionCreator.async<string[], any>('GET_INGREDIENTS_BATCH');
export const editIngredientTolerance = actionCreator.async<EditTolerancePayload, any>('EDIT_INGREDIENT_TOLERANCE');
export const editIngredientSettings = actionCreator.async<EditIngredientSettingsPayload, any>(
  'EDIT_INGREDIENT_SETTINGS',
);
export const getIngredientStocks = actionCreator.async<string, IngredientStock[]>('GET_INGREDIENT_STOCKS');
export const getIngredientDailyUsage = actionCreator.async<string, DailyUsage[]>('GET_INGREDIENT_DAILY_USAGE');
export const editIngredientInventory = actionCreator.async<EditIngredientPayload, Ingredient>(
  'EDIT_INGREDIENT_INVENTORY',
);
export const addIngredientInventoryStock = actionCreator.async<AddInventoryStockPayload, IngredientStock>(
  'ADD_INGREDIENT_INVENTORY_STOCK',
);
